import Moment from "moment";
import {extendMoment} from "moment-range";
import {split} from "moment-range-split";

const moment = extendMoment(Moment);

export default {
    methods: {
        validateImportCampaigns(rowsData) {
            try {
              let result = {
                isSuccess: true,
                errorRows: []
              };

              this.sampleImportExcelErrorConfig.data = [];
              for (let i = 0; i < rowsData.length; i++) {
                if (!rowsData[i].cost) {
                  result.isSuccess = false;
                  result.errorRows.push({
                    rowIndex: i + 2,
                    note: "Chi phí không được để trống!",
                  });
                }

                if (!rowsData[i].campaign_id) {
                    result.isSuccess = false;
                    result.errorRows.push({
                      rowIndex: i + 2,
                      note: "Campaign id không được để trống!",
                    });
                }

                if (!rowsData[i].startDate) {
                    result.isSuccess = false;
                    result.errorRows.push({
                      rowIndex: i + 2,
                      note: "Ngày bắt đầu không được để trống!",
                    });
                }

                if (!rowsData[i].endDate) {
                    result.isSuccess = false;
                    result.errorRows.push({
                      rowIndex: i + 2,
                      note: "Ngày kết thúc không được để trống!",
                    });
                }

                // check split weeks
                const start = moment(rowsData[i].startDate).startOf('month')
                const end = moment(rowsData[i].endDate).endOf('month')
                const weeks = this.splitWeeks(start.format('yyyy-MM-DD'), end.format('yyyy-MM-DD'))
                weeks.forEach(w => {
                    console.log(w.start.format('yyyy-MM-DD'), w.end.format('yyyy-MM-DD'))
                })
                const existWeek = weeks.find(w => w.start.format('yyyy-MM-DD') === rowsData[i].startDate && w.end.format('yyyy-MM-DD') === rowsData[i].endDate)
                if(!existWeek){
                    result.isSuccess = false;
                    result.errorRows.push({
                      rowIndex: i + 2,
                      note: "Ngắt tuần không hợp lệ!",
                    });
                }
              }

              return result;
            } catch (error) {
              console.log(error);
              return {
                isSuccess: false,
                errorRows: [{
                    rowIndex: 0,
                    note: 'Đã có ngoại lệ xảy ra!'
                }]
              };
            }
        },
        splitWeeks(startDate, endDate) {
            const splitMonths = this.splitDateTime(startDate, endDate, "months");
            const weeks = [];
            for (let i = 0; i < splitMonths.length; i++) {
              const splitWeeks = this.splitDateTime(
                splitMonths[i].start.format("yyyy-MM-DD"),
                splitMonths[i].end.format("yyyy-MM-DD"),
                "weeks"
              );
              weeks.push(...splitWeeks);
            }

            return weeks;
        },
        splitDateTime(startDate, endDate, rangeType) {
            const range = moment.range(startDate, endDate);
            const ranges = split(range, rangeType);

            for (let i = 0; i < ranges.length; i++) {
              if (i === 0) ranges[i].start = moment(startDate);

              if (i === ranges.length - 1) {
                ranges[i].end = moment(endDate);
              } else ranges[i].end = ranges[i].end.add(-1, "days");
            }

            // last week of month
            if (rangeType === "weeks") {
              const lastIndex = ranges.length - 1;
              if (ranges[lastIndex].end.diff(ranges[lastIndex].start, "days") === 7) {
                const newRange = {
                  start: moment(ranges[lastIndex].end.format("yyyy-MM-DD")),
                  end: moment(ranges[lastIndex].end.format("yyyy-MM-DD")),
                };
                ranges[lastIndex].end = ranges[lastIndex].end.add(-1, "days");
                ranges.push(newRange);
              }
            }

            return ranges;
        },
    }
}
